import { createAction } from '@reduxjs/toolkit';

export const setProductsList = createAction('products/setProductsList');
export const setIsLoading = createAction('products/setIsLoading');
export const setTotalCount = createAction('products/setTotalCount');
